<template>
  <div class="block-wrap oa-stat_oat" :class="{ [curTheme]: true }">
    <div class="oat_img-wrap">
      <img
        :src="img"
        class="oat_img">
    </div>
    <div class="oat_rows">
      <div
        v-if="data.length"
        v-for="(o, i) in data"
        class="oat_row"
        :class="{ 'oat_row--first': !i,
                  'oat_row--last': i+1 === data.length }"
        :key="`ud-${i}`">
        <div class="oat_title-cell">{{ o.Title }}</div>
        <div class="oat_value-cell">
          <div class="oat_value-wrap">
            <span class="oat_value">{{ o.Value }}</span>
            <sup
              class="oat_new-value"
              title="Новых с последнего посещения."
              v-if="typeof o.NewValue !== 'undefined'">
              +{{ o.NewValue }}</sup>
            <span
              class="oat_inc-value"
              v-if="typeof o.IncValue !== 'undefined'">
                <i class="oat_val-arrow">↑</i>
                {{ o.IncValue }}
            </span>
            <span
              class="oat_dec-value"
              v-if="typeof o.DecValue !== 'undefined'">
              <i class="oat_val-arrow">↓</i>
              {{ o.DecValue }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="links" class="oat_links">
      <div v-for="(o, i) in links" :key="`link-${i}`">
        <router-link :to="o.to">{{ o.text }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    links: Array,
    img: String,
    data: Array,
  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";

.oa-stat_oat {
  position: relative;
  margin-bottom: 32px !important;
  min-height: 190px;
  text-align: right;
  padding: 30px 0 0 !important;
  @include clearfix;
  @media (max-width: 930px) {
    margin: 10px 0 !important;
  }
  @media (max-width: 480px) {
    min-height: auto !important;
  }
  .oat_img-wrap {
    position: absolute;
    top: 30px;
    left: 30px;
    background: rgba(255, 255, 255, .85);
    padding: 15px;
    @include border-radius(50%);
    width: 80px;
    height: 80px;
    overflow: hidden;
    @include box-shadow(0 0 5px rgba(255, 255, 255, .4));
    .oat_img {
      width: 100%;
      height: auto;
    }
    @media (max-width: 480px) {
      display: none;
    }
  }
  .oat_rows {
    display: table;
    float: right;
    margin-bottom: 90px;
    padding-left: 15px;
    @media (max-width: 600px) {
      margin-bottom: 60px;
    }
  }
  .oat_row {
    padding: 5px 0;
    display: table-row;
    &.oat_row--first {
      .oat_title-cell {
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
      }
    }
    .oat_title-cell {
      display: table-cell;
      vertical-align: middle;
      padding-right: 5px;
      padding-bottom: 5px;
      line-height: 15px;
    }
    .oat_value-cell {
      display: table-cell;
      padding-bottom: 7px;
    }
    .oat_value-wrap {
      vertical-align: middle;
      padding: 5px 10px;
      background: rgba(255, 255, 255, .85);
      @include box-shadow(0 0 5px rgba(255, 255, 255, .4));
      color: #000;
      @include border-radius(5px 0 0 5px);
      min-width: 70px;
      text-align: left;
    }
    .oat_value {
      font-weight: 400;
    }
    .oat_new-value {
      padding: 0 5px;
      background: lighten($color-2, 30%);
      @include border-radius(4px);
      font-size: 12px;
      text-align: right;
      cursor: default;
    }
    .oat_val-arrow {
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      display: inline-block;
      vertical-align: top;
    }
    .oat_inc-value {
      margin-left: 5px;
      color: #1aa69d;
    }
    .oat_dec-value {
      margin-left: 5px;
      color: #d6757d;
    }
  }
  .oat_links {
    position: absolute;
    left: 30px;
    bottom: 30px;
    color: #fff;
    text-align: left;
    @media (max-width: 600px) {
      position: static;
      display: block;
      clear: both;
      padding: 0 30px 30px;
    }
    @media (max-width: 500px) {
      padding: 0 15px 15px;
    }
    a {
      display: inline-block;
      border-bottom: 1px dotted #fff;
      line-height: 17px;
      margin-top: 10px;
      @include transition;
      &:hover {
        border-bottom: 1px dotted transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/OrgAdminStat.vue